.scenarioTitleAndColourFields {
	display: flex;
	gap: calc(2 * var(--jpo-common-base-spacing));
}

.scenarioTitle {
	flex: 1;
}

.scenarioColour {
	padding-top: 27px;
}

.hiddenSubmitButton {
	display: none;
}

.radioGroup div {
	margin-top: 0;
}
